module.exports = __webpack_public_path__ + "50705c5ed1205b63efdbfee941a6b655.ttf";